import { IAiLibImageState } from 'store/types/aiLibImage'

export const getInitialState = (): IAiLibImageState => ({
  isFiltersOpen: false,
  isLoaded: false,
  isInitialLoading: false,
  isLoadingMore: false,
  historyList: [],
  historyTotalCount: 0,
  filters: {
    modelCode: null,
    aspectRatio: null,
    styleId: null,
    imageType: null,
    isHistoryScopedToCurrentProject: false
  }
})
